<template>
  <div class="payment-body" :class="{'mobile-body': windowWidth < 768}">
    <div class="container container-custom container-payment-body">
      <div class="row">
        <div class="col-sm-12 mobile-pd-off">
          <div class="payment-body-content">
            <div class="page-loader-content" v-if="!isDetailReceived">
              <div class="wrap-page-loader">
                <div class="loading">
                  <div class="bounceball"></div>
                  <div class="text">Verifying Link</div>
                </div>
              </div>
            </div>
            <mobile-header  :customerData="customerData" v-if="isDetailReceived && windowWidth < 768" />
            <PaymentInfoBox v-if="isDetailReceived" :customerData="customerData" />
            <PaymentCard v-if="isDetailReceived && showPaymentBox" :customerData="customerData" />
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaymentInfoBox from "./PaymentInfoBox";
import PaymentCard from "./PaymentCard";
import Promise from "../../../lib/mixins/ExtendedPromises";
import customerDetail from "../../../repositories/customerDetail";
import MobileHeader from './MobileHeader.vue';
export default {
  name: "PaymentBody",
  mixins: [Promise],
  components: {
    PaymentCard,
    PaymentInfoBox,
    MobileHeader
  },
  mounted() {
    this.getCustomerDetail();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.onResize();
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  data () {
      return {
          linkParam: '',
          customerData: '',
          isDetailReceived: false,
          windowWidth: window.innerWidth,
          showMobileLayout: false,
          showPaymentBox: true,
          showSecondaryStep: false
      }
  },
  methods: {
    updateStep(){
      this.showSecondaryStep = true;
    },
    onResize() {
      this.windowWidth = window.innerWidth;

      if( this.windowWidth < 768 && !this.showSecondaryStep) {
        this.showMobileLayout = true;
        this.showPaymentBox = false;
      } else {
        this.showMobileLayout = false;
        this.showPaymentBox = true;
      }

      // this.$emit('getWindowSize', this.windowWidth)

    },
    showPaymentForm() {
      this.showPaymentBox = true;
    },
    getCustomerDetail() {
      let id = this.$route.params.id;
      this.linkParam = id;

      const operation = this.response(customerDetail.getPaymentDetail(id));
      operation
        .then(data => {
          if (operation.isFulfilled()) {
            this.isDetailReceived = true;
            this.customerData = data.data;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    }
  }
};
</script>
